module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "package_icon.ca6a1e85.png" + "?" + Date.now();